import config from "config"
import { action, observable } from "mobx"
import _ from "lodash"
import languageStore from "stores/languageStore"

class CmsStore {

	@observable list = []
	@observable pageBySlug = new Map()

	@observable moduleBySlug = new Map()
	@observable modules = []
	@observable config = {}
	@observable isEditor = false
	@observable useEditor = false
	@observable contentByCategory = new Map()
	@observable plugins = {}
	@observable pluginData = {}

	filter_defaults = {}

	constructor() {
		this.load()
		this.fetchPluginData()
	}

	@action
	load() {
		this.getRole()
		const {currentLanguage} = languageStore
		let url = config.CMS_BASE + "/wp-json/wp/v2/shop?lang=" + currentLanguage + "&per_page=100"
		return fetch( url, {
			mode: "cors",
			credentials: 'include'
		} )
			.then( response => response.json() )
			.then( modules => {
				modules.forEach( page => {
					if ( !page || !page.acf ) return
					let {cat_id} = page.acf
					this.contentByCategory.set( cat_id, page )
				} )
			} )
			.catch( err => this.handleError( err, "Shop Config" ) )
	}

	@action
	getRole() {
		fetch( `${config.CMS_BASE}/wp-admin/edit.php`, {credentials: "include"} )
			.then( res => res.redirected )
			.then( wasRedirected => {
				if ( !wasRedirected ) this.isEditor = true
			} ).catch( err => {
			// console.error( err )
			if ( document.location.hostname === "localhost" ) this.isEditor = true
		} )
	}

	handleError( err, text ) {
		console.error( `err`, err, text )
	}

	@action
	toggleEditor() {
		if ( this.isEditor ) {
			this.useEditor = !this.useEditor
			// reload content (maybe changed)
			if ( !this.useEditor ) this.load()
		}
	}

	@action
	addConfig( key, config ) {
		if ( this.config[key] ) console.warn( "Overwriting config", key )
		this.config[key] = config
	}

	@action
	async fetchPluginData() {
		try {
			const url = `${config.CMS_BASE}/wp-json/acf/v3/options/bshop-config-plugin`
			// TODO: NON LOCAL DEV
			// const url = `http://localhost:8000/wp-json/acf/v3/options/bshop-config-plugin`
			this.pluginData = await fetch( url )
				.then( res => res.json() )
				.then( data => data.acf )

			_.each( this.pluginData, ( item, key ) => {
				try {
					const config = item.config || item
					if ( !config.json ) return
					const cleanJSON = config.json.replace( /\\n/g, "\\n" )
						.replace( /\\'/g, "\\'" )
						.replace( /\\"/g, '\\"' )
						.replace( /\\&/g, "\\&" )
						.replace( /\\r/g, "\\r" )
						.replace( /\\t/g, "\\t" )
						.replace( /\\b/g, "\\b" )
						.replace( /\\f/g, "\\f" );

					this.pluginData[key] = {
						active: config.active,
						json: JSON.parse( cleanJSON )
					}

					if ( !config.active ) {
						this.pluginData[key] = false
					}
				} catch (err) {
					console.warn( `Error in plugin-data ${key}`, err )
					// nOOP
				}
			} )

		} catch (err) {
			console.info( "Plugin Config not available - upgrade Backend" )
			this.pluginData = {}
		}

	}

	@action
	getConfig() {
		this.config = this.config || {}
		this.config.plugins = this.config.plugins || []
		this.config.plugin = this.config.plugin || {}
		this.config.checkoutFeatures = this.config.checkoutFeatures || {}
		this.config.checkout = this.config.checkout || {}
		this.config.standards = this.config.standards || {}
		this.config.filter_defaults = this.config.filter_defaults || {}
		//if WP cors Fehler, dann in Wordpress ACF to Custom Fields -> Permalinks -> Post name
		const url = `${config.CMS_BASE}/wp-json/acf/v3/options/bshop-config`
		return fetch( url, {
			credentials: "include"
		} )
			.then( response => response.json() )
			.then( data => data.acf )
			.then( config => {

				console.log('get cms config:',config);
				config.logo = config.logo || "https://www.blandland.de/wp-content/uploads/2012/10/BLANDLAND-LOGO-BLACK1.png"

				// TODO: create Config Class
				config.plugin = config.plugin || []
				if ( config.availability ) {
					this.parseAvailability( config )
				}

				if ( config.plugins ) {
					config.plugins.forEach( id => {
							config.plugin[id] = true
						}
					)
				}

				let checkoutFeatures = {}
				if ( config.checkoutFeatures ) {
					config.checkoutFeatures.forEach( id => {
							checkoutFeatures[id] = true
						}
					)
				}
				config.checkoutFeatures = checkoutFeatures

				let collections = {}
				if ( config.collections ) {
					config.collections.forEach( id => {
							collections[id] = true
						}
					)
				}
				config.collections = collections


				config.checkout = config.checkout || []
				let checkout = {}
				config.checkout.forEach( id => {
						checkout[id] = true
					}
				)
				
				this.config.standards = config.standards || {}
				this.config.MIN_ORDER_VALUE = this.config.MIN_ORDER_VALUE || this.config.standards.MIN_ORDER_VALUE || this.config.MIN_ORDER_VALUE
				this.config.pageSize = this.config.standards.ITEMS_PER_PAGE || this.config.pageSize
				config.filter_defaults = Object.assign( this.config.filter_defaults, config.filter_defaults || {} )
				config.standards = Object.assign( this.config.standards, config.standards || {} )
				config.variantNames = this.config.variantNames || ""
				Object.assign( this.config, config )
				this.config.checkout = checkout

				if ( this.config.filter_selection ) console.warn( "Shop Config filter_selection is marked for removal. Please upgrade backend" )

				this.config.pickFilter = this.config.pickFilter || this.config.filter_selection

				return this.config
			} )
			.catch( err => {
				console.error( `Error: cmsStore:config: ${err}` )
				return {}
			} )
	}

	parseAvailability( config ) {
		const yellow = {}
		const red = {}
		_.forEach( config.availability.yellow_ByCategory, ( constraint => {
			yellow[constraint.category.trim()] = constraint.count
		} ) )

		_.forEach( config.availability.red_ByCategory, ( constraint => {
			red[constraint.category.trim()] = constraint.count
		} ) )

		config.availability.yellow = yellow
		config.availability.red = red

		this.config.availability = config.availability
	}

	@action
	getPage( slug ) {
		const {currentLanguage} = languageStore
		let cached = this.pageBySlug.get( slug )
		if ( cached ) return new Promise( resolve => resolve( cached ) )

		let url = config.CMS_BASE + "/wp-json/wp/v2/pages/?slug=" + slug + "&lang=" + currentLanguage
		return fetch( url, {
			mode: "cors",
			credentials: 'include'
		} )
			.then( response => response.json() )
			.then( page => page[0] )
			.then( page => {
				this.pageBySlug.set( slug, page )
			} )
			.catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", slug, err ) )
	}

	@action
	getModule( slug ) {
		const {currentLanguage} = languageStore
		let url = config.CMS_BASE + "/wp-json/wp/v2/shop/?slug=" + slug + "&lang=" + currentLanguage
		return fetch( url, {
			mode: "cors",
			credentials: 'include'
		} )
			.then( response => response.json() )
			.then( page => page[0] )
			.then( page => {
				this.pageBySlug.set( slug, page )
				return page
			} )
			.catch( err => console.error( "Fehler beim Laden der CMS Inhalte:", slug, err ) )
	}

}

const cmsStore = new CmsStore()

window.cmsStore = cmsStore

export default cmsStore



// WEBPACK FOOTER //
// ./src/stores/cmsStore.js